// import {  } from "../actions/types";
import { getTurbines } from "../testData/turbines";

const initialState = {
  turbines: getTurbines(),
};

export default function (state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
